import React from "react";
import Carousel from "react-bootstrap/Carousel";
import { assest } from "../Assest/Assest";
import { useNavigate } from "react-router-dom";

// Reusable TextContent component with dynamic content
function TextContent({ title, subtitle, buttonText, buttonLink }) {
  const navigate = useNavigate();

  return (
    <div
      style={{
        maxWidth: "500px",
        margin: "10px",
        animation: "fadeInLeft 1.5s ease-in-out",
        textAlign: "center",
      }}
    >
      <h1
        style={{
          fontSize: "3rem",
          color: "black",
          fontWeight:"700",
          marginBottom: "20px",
          lineHeight: "1.4",
        }}
      >
        {title}
      </h1>
      <p
        style={{
          fontSize: "1.7rem",
          marginBottom: "20px",
          fontWeight:"700",
          color: "black",
          lineHeight: "1.6",
        }}
      >
        {subtitle}
      </p>
      <button
        style={{
          padding: "10px 20px",
          backgroundColor: "#00246B",
          color: "#FFF",
          fontWeight:"700",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontSize: "1rem",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          transition: "transform 0.3s ease, background-color 0.3s ease",
        }}
        onMouseOver={(e) => {
          e.target.style.transform = "scale(1.1)";
          e.target.style.backgroundColor = "#001D4F";
        }}
        onMouseOut={(e) => {
          e.target.style.transform = "scale(1)";
          e.target.style.backgroundColor = "#00246B";
        }}
        onClick={() => navigate(buttonLink)}
      >
        {buttonText}
      </button>
    </div>
  );
}

function CombinedPage() {
  const sliderData = [
    {
      image: assest.invi1,
      title: "Advanced Invisalign Treatment",
      subtitle: "Achieve a perfect smile with our clear aligners.",
      buttonText: "Book An Appointment",
      buttonLink: "/bookanappointment",
    },
    {
      image: assest.invi2,
      title: "Painless Root Canal Therapy",
      subtitle: "State-of-the-art technology for your comfort.",
      buttonText: "Book An Appointment",
      buttonLink: "/bookanappointment",
    },
    {
      image: assest.invi3,
      title: "Cosmetic Dentistry",
      subtitle: "Enhance your smile with our expert treatments.",
      buttonText: "Book An Appointment",
      buttonLink: "/bookanappointment",
    },
  ];

  return (
    <>
      <Carousel controls={false} indicators={false} style={{ width: "100%", height: "auto", overflow: "hidden" }}>

        {/* First Slide - Fixed Content */}
        <Carousel.Item interval={3000}>
          <div
            style={{
              backgroundColor: "#CADCFC",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
              padding: "20px",
              minHeight: "80vh",
            }}
          >
            <TextContent
              title="Dentin Dental Care & Implant Center"
              subtitle="Dentin, first in-house CBCT X-ray clinic in Erode"
              buttonText="Book An Appointment"
              buttonLink="/bookanappointment"
            />
            <div
              style={{
                margin: "10px",
                animation: "fadeInRight 1.5s ease-in-out",
              }}
            >
              <img
                style={{
                  width: "100%",
                  maxWidth: "370px",
                  height: "auto",
                  transition: "transform 0.5s ease",
                }}
                src={assest.Docter}
                alt="Doctor"
                onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
              />
            </div>
          </div>
        </Carousel.Item>

        {/* Additional Slides */}
        {sliderData.map((slide, index) => (
          <Carousel.Item key={index} interval={3000}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "80vh",
                background: `url(${slide.image}) center/cover no-repeat`,
                textAlign: "center",
                padding: "20px",
                color: "#FFF",
              }}
            >
              <TextContent
                title={slide.title}
                subtitle={slide.subtitle}
                buttonText={slide.buttonText}
                buttonLink={slide.buttonLink}
              />
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </>
  );
}

export default CombinedPage;
